import {
  faArrowRight,
  faClipboardCheck,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Assignment from 'models/Assignment';
import React from 'react';
import { FilterOption } from 'view/components/common/Filter';
import ItemPanel from 'view/components/common/ItemPanel';
import StatusIcon from 'view/components/common/StatusIcon';

interface TeacherAssignmentListProps {
  assignments: Assignment[];
  selectedAssignment?: Assignment;
  averages?: Record<string, any>;
  averageDisplay: FilterOption;
  onSelectAssignment: (assignment: Assignment) => void;
  onEnterAssignment: () => void;
  onViewSubmissions: (event: any, assignment: Assignment) => void;
}

const TeacherAssignmentList: React.FC<TeacherAssignmentListProps> = ({
  assignments,
  selectedAssignment,
  averages,
  averageDisplay,
  onSelectAssignment,
  onEnterAssignment,
  onViewSubmissions,
}) => {
  return (
    <>
      {assignments &&
        assignments.map((assignment) => (
          <ItemPanel
            key={`assignment-${assignment.getId()}`}
            id={`assignment-${assignment.getId()}`}
            selected={selectedAssignment === assignment}
            onClick={() => onSelectAssignment(assignment)}
            onDoubleClick={onEnterAssignment}
          >
            <div className="student-row-info">
              <span className="label-normal">{assignment.title}</span>
              <StatusIcon
                icon={faClipboardCheck}
                color="var(--dark-green)"
                text="Submissions"
                onClick={(event) => onViewSubmissions(event, assignment)}
              />
            </div>
            {selectedAssignment === assignment ? (
              <>
                <span className="label-medium">Edit</span>
                <FontAwesomeIcon icon={faArrowRight} size="xl" />
              </>
            ) : (
              averageDisplay &&
              averageDisplay.alias &&
              averages?.assignments[assignment.id] && (
                <span className="label-small">
                  {averageDisplay?.value} Average:{' '}
                  {
                    averages?.assignments[assignment.id][
                      averageDisplay?.alias as
                        | 'grade'
                        | 'completion_score'
                        | 'correctness_score'
                        | 'key_word_accuracy_score'
                        | 'completion_time'
                    ]
                  }
                  %
                </span>
              )
            )}
          </ItemPanel>
        ))}
    </>
  );
};

export default TeacherAssignmentList;
